import flattenDeep from 'lodash/flattenDeep';
import { contentTypes, stepTypes } from '../step/step-constants';
import { stepModel } from '../step/step-model';

function isExtendedSpeaking(step) {
  return step.type === stepTypes.EXTENDED_SPEAKING;
}

function isExtendedWriting(step) {
  return step.type === stepTypes.EXTENDED_WRITING;
}

function parseExtendedSpeakingData(step) {
  var content = step.content[0];
  return {
    texts: stepModel.parseContentByType(contentTypes.TEXT, step.content),
    images: stepModel.parseContentByType(contentTypes.IMAGES, content),
    audios: stepModel.parseContentByType(contentTypes.AUDIOS, content)
  };
}

function parseExtendedWritingData(step) {
  var content = flattenDeep(step.content);
  return {
    images: stepModel.parseContentByType(contentTypes.IMAGES, content),
    audios: stepModel.parseContentByType(contentTypes.AUDIOS, content),
    videos: stepModel.parseContentByType(contentTypes.VIDEOS, content),
    texts: stepModel.parseContentByType(contentTypes.TEXT, step.content)
  };
}

export var stepExpertModel = {
  isExtendedSpeaking: isExtendedSpeaking,
  isExtendedWriting: isExtendedWriting,
  parseExtendedSpeakingData: parseExtendedSpeakingData,
  parseExtendedWritingData: parseExtendedWritingData
};